// Use SQL script to generate the following:
/*

WITH cte_roles
AS (
     SELECT replace(ROLE, ' ', '') + ': ''' + ROLE + ''',' role_data
     FROM dbo.roles
     )
SELECT 'export const roles = {' + (
          SELECT role_data + ''
          FROM cte_roles
          FOR XML path('')
          ) + '};' result

*/

export const roles = {
  ALL: 'ALL',
  Admin: 'Admin',
  User: 'User',
  WarehouseLead: 'Warehouse Lead',
  WarehouseManager: 'Warehouse Manager',
  WarehouseInventory: 'Warehouse Inventory',
  WarehouseLTL: 'Warehouse LTL',
  WarehouseParcel: 'Warehouse Parcel',
  SalesConsultant: 'Sales Consultant',
  SalesOperations: 'Sales Operations',
  SalesManager: 'Sales Manager',
  Warehouse: 'Warehouse',
  Accounting: 'Accounting',
  AccountingLead: 'Accounting Lead',
  AccountingManager: 'Accounting Manager',
  LogisticsManager: 'Logistics Manager',
  LogisticsCoordinator: 'Logistics Coordinator',
  SCM: 'SCM',
  SCMLead: 'SCM Lead',
  SCMManager: 'SCM Manager',
  IT: 'IT',
  Leadership: 'Leadership',
  CCAdvisor: 'CC Advisor',
  CCLead: 'CC Lead',
  CCManager: 'CC Manager',
  AccountManagement: 'Account Management',
  Marketing: 'Marketing',
  MarketingManager: 'Marketing Manager',
};

export const superAdminRoles = [
  roles.ALL,
  roles.Admin,
  roles.IT,
  roles.Leadership,
];

const salesRoles = [
  roles.SalesConsultant,
  roles.SalesOperations,
  roles.SalesManager,
  roles.AccountManagement,
];

export const accountingRoles = [
  roles.Accounting,
  roles.AccountingLead,
  roles.AccountingManager,
];

const warehouseRoles = [
  roles.WarehouseLead,
  roles.WarehouseManager,
  roles.WarehouseInventory,
  roles.WarehouseLTL,
  roles.WarehouseParcel,
  roles.Warehouse,
];

export const creditMemoVisibleRoles = [
  roles.ALL,
  roles.Admin,
  roles.SalesOperations,
  roles.SalesManager,
  roles.AccountingManager,
  roles.LogisticsManager,
  roles.SCMManager,
  roles.Leadership,
  roles.CCAdvisor,
  roles.CCLead,
  roles.CCManager,
  roles.AccountManagement,
  roles.MarketingManager,
];

const shippingQueueRoles = [roles.ALL, roles.LogisticsManager];
export const supplyChainRoles = [
  roles.SCM,
  roles.SCMLead,
  roles.SCMManager,
  roles.LogisticsManager,
  roles.LogisticsCoordinator,
];
const marketingRoles = [roles.Marketing, roles.MarketingManager];

export const contactRoles = {
  CustomsBroker: 'Customs Broker',
  FreightBroker: 'Freight Broker',
};

export const customerCareRoles = [
  roles.CCAdvisor,
  roles.CCLead,
  roles.CCManager,
  roles.AccountManagement,
];

export const groups = {
  requestReviewVisible: [...superAdminRoles, ...customerCareRoles],
  unitCostVisible: [
    ...superAdminRoles,
    ...salesRoles,
    ...accountingRoles,
    ...supplyChainRoles,
  ],
  productionWarehouseVisible: [
    ...superAdminRoles,
    roles.SalesOperations,
    roles.SalesManager,
  ],
  rankDateVisible: [
    ...superAdminRoles,
    roles.SalesManager,
    roles.SalesOperations,
  ],
  deletePOLine: [
    ...superAdminRoles,
    ...supplyChainRoles,
    roles.SalesManager,
    roles.SalesOperations,
  ],
  authorizedToReleasePaymentRequiredFlag: [
    ...accountingRoles,
    ...superAdminRoles,
    roles.CCLead,
    roles.CCManager,
    roles.SalesManager,
    roles.SalesOperations,
  ],
  editVendorSupplierDocumentLinks: [
    ...supplyChainRoles,
    ...superAdminRoles,
    roles.SalesManager,
  ],
  seeAllPaymentTypes: [...superAdminRoles, ...accountingRoles],
  editVendorSupplierNotes: [
    ...supplyChainRoles,
    ...superAdminRoles,
    roles.SalesManager,
  ],
  errorLogAdmin: [
    roles.ALL,
    roles.Admin,
    roles.CCLead,
    roles.CCManager,
    roles.SalesOperations,
    roles.SalesManager,
    roles.SCMLead,
    roles.SCMManager,
    roles.WarehouseManager,
  ],
  errorListSalesSupport: [
    roles.SalesConsultant,
    roles.SalesManager,
    roles.SalesOperations,
  ],
  errorListWarehouse: [
    roles.WarehouseLead,
    roles.WarehouseManager,
    roles.Warehouse,
  ],
  warehouseRoles: [...warehouseRoles],
  worldEaseAdminRoles: [
    ...shippingQueueRoles,
    ...superAdminRoles,
    ...warehouseRoles,
  ],
  errorListCustomerCare: [
    roles.CCAdvisor,
    roles.CCLead,
    roles.CCManager,
    roles.AccountManagement,
  ],
  marketingRoles: [roles.Marketing, roles.MarketingManager],
  supplyChainVisible: [
    ...supplyChainRoles,
    ...superAdminRoles,
    ...marketingRoles,
  ],
  shippingQueueVisibleRoles: [...shippingQueueRoles, ...superAdminRoles],
  salesManager: [...superAdminRoles, roles.SalesManager, roles.SalesOperations],
  salesManagerNoSalesOps: [...superAdminRoles, roles.SalesManager],
  authorizedToChangeRepInOrders: [...superAdminRoles, ...salesRoles],
};

export const users = {
  customerService: 'CUSTOMER.SERVICE',
  accountManagement: 'ACCOUNT.MANAGEMENT',
};
